import { ENGLISH, LEFT_TO_RIGHT } from "../state/actions/localization.action";

export default {
  name: ENGLISH,
  dir: LEFT_TO_RIGHT,
  sign: "E",
  header: {
    home: "Home",
    islamic: "Islamic",
    documentary: "Documentary",
    kids: "Kids"
  }
};
